module.exports = __webpack_public_path__ + "assets/img/email.28a67d74.svg";